import React, { useState, useEffect, useRef } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useOnClickOutside } from "../../hooks";
import Link from "gatsby-plugin-transition-link";

import Burger from "./Burger";
import OffCanvas from "./OffCanvas";
import PromoBar from "./PromoBar";
import ButtonSolid from "../Button/ButtonSolid";
import ButtonGhost from "../Button/ButtonGhost";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemState,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { StaticImage } from "gatsby-plugin-image";
import clsx from "clsx";

const MainNav = ({ headerStyle, scrolled, offcanvasOffset, customTheme }) => {
  // determine if offcanvas is open
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);

  // determine button styles
  const [buttonAltStyle, setButtonAltStyle] = useState(0);

  const [subMenuHovering1, setSubMenuHovering1] = useState(false);
  const isHoveringSubMenu1 = () => setSubMenuHovering1(true);
  const notHoveringSubMenu1 = () => setSubMenuHovering1(false);

  const [subMenuHovering2, setSubMenuHovering2] = useState(false);
  const isHoveringSubMenu2 = () => setSubMenuHovering2(true);
  const notHoveringSubMenu2 = () => setSubMenuHovering2(false);

  // const [subMenuHovering3, setSubMenuHovering3] = useState(false);
  // const isHoveringSubMenu3 = () => setSubMenuHovering3(true);
  // const notHoveringSubMenu3 = () => setSubMenuHovering3(false);

  const [subMenuHovering4, setSubMenuHovering4] = useState(false);
  const isHoveringSubMenu4 = () => setSubMenuHovering4(true);
  const notHoveringSubMenu4 = () => setSubMenuHovering4(false);

  const [subMenuHovering5, setSubMenuHovering5] = useState(false);
  const isHoveringSubMenu5 = () => setSubMenuHovering5(true);
  const notHoveringSubMenu5 = () => setSubMenuHovering5(false);

  // handle click of navigation items
  const clickHandler = () => {
    setOffcanvasOpen(!offcanvasOpen);
  };

  // close offcanvas onclick outside
  const node = useRef();
  useOnClickOutside(node, () => setOffcanvasOpen(false));

  useEffect(() => {
    headerStyle !== "overlap" && scrolled === false
      ? setButtonAltStyle(0)
      : headerStyle === "overlap" && scrolled === false
      ? setButtonAltStyle(2)
      : setButtonAltStyle(0);
  }, [buttonAltStyle, scrolled, headerStyle]);

  const data = useStaticQuery(graphql`
    {
      darkLogo: file(relativePath: { eq: "global/Logo-Black.svg" }) {
        publicURL
      }
      lightLogo: file(relativePath: { eq: "global/Logo-White.svg" }) {
        publicURL
      }
    }
  `);

  // Define logos based on header style
  let logo = null;

  if (headerStyle === "overlap") {
    logo = data.lightLogo.publicURL;
  } else {
    logo = data.darkLogo.publicURL;
  }

  if (scrolled) {
    logo = data.darkLogo.publicURL;
  }

  if (offcanvasOpen) {
    logo = data.darkLogo.publicURL;
  }

  const navigation = {
    product: [
      {
        name: "Business Intelligence Platform",
        href: "/product/business-intelligence/",
      },
    ],
    integrations: [
      {
        name: "How It Works",
        href: "/how-it-works/",
      },
      {
        name: "Supported Systems",
        href: "/real-estate-software-integrations/",
      },
    ],
    successStories: [
      {
        name: "Case Studies",
        href: "/product/case-studies/",
      },
      {
        name: "Testimonials",
        href: "/reviews/",
      },
    ],
    pricing: [
      {
        name: "Pricing & Features",
        href: "/price/",
      },
      {
        name: "Software Partners",
        href: "/partner-pricing/",
      },
      {
        name: "Real Estate Teams",
        href: "/client-pricing/",
      },
    ],
    resources: [
      {
        name: "Blog",
        href: "/blog/",
      },
      // {
      //   name: "Support",
      //   href: "https://support.realsynch.com/",
      //   outbound: "_blank",
      // },
    ],
    // testimonials: [
    //   {
    //     name: "Client Reviews",
    //     href: "/reviews/",
    //   },
    //   {
    //     name: "Case Studies",
    //     href: "/case-studies/",
    //   },
    // ],
  };
  const navClasses = clsx(
    "w-full py-4 transition duration-300 ease-linear",
    headerStyle === "overlap"
      ? "absolute bg-transparent lg:bg-transparent"
      : "lg:bg-white",
    offcanvasOpen && "!bg-white",
    scrolled && "!fixed top-0 left-0 z-50 w-full !bg-white !shadow-4xl",
    customTheme === "light-pink" ? "lg:!bg-[#f1eefb]" : ""
  );

  return (
    <nav
      id="main-navigation"
      className={navClasses}
      role="navigation"
      aria-label="main-navigation"
    >
      {/* <Link
        className="no-underline"
        to="/synch-your-phone-with-your-crm-in-real-time/"
      >
        <PromoBar />
      </Link> */}
      <div className="container flex items-center justify-between px-2 lg:grid lg:grid-cols-3">
        <div className="flex flex-auto lg:hidden">
          {/* <Link
            className=" relative z-30 flex h-4 w-auto cursor-pointer flex-col justify-between border-0 bg-transparent focus:outline-none"
            href="tel:8582156066"
            headerStyle={headerStyle}
            scrolled={scrolled}
          >
            <div
              className={` far fa-phone relative z-10 h-[2px] w-6 transition-all duration-300 ease-linear ${
                headerStyle === "overlap" ? "bg-white" : "bg-gray-900"
              } ${scrolled && "bg-gray-900"} ${offcanvasOpen && "bg-gray-900"}`}
            />

            <div
              className={`line relative z-10 h-[2px] w-6 transition-all duration-300 ease-linear ${
                headerStyle === "overlap" ? "bg-white" : "bg-gray-900"
              } ${scrolled && "bg-gray-900"} ${
                offcanvasOpen && "bg-gray-900"
              } ${offcanvasOpen && "opacity-0"}`}
            />
            <div
              className={`line relative z-10 h-[2px] w-6 transition-all duration-300 ease-linear ${
                headerStyle === "overlap" ? "bg-white" : "bg-gray-900"
              } ${scrolled && "bg-gray-900"} ${offcanvasOpen && "bg-gray-900"}`}
            />
          </Link> */}
          <a href="tel:8582156066" className="p-2">
            <svg
              className={`  ${
                headerStyle === "overlap" ? "text-white" : "text-gray-900"
              } ${scrolled && "text-gray-900 "} ${
                offcanvasOpen && "text-gray-900"
              }`}
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill=""
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.58124 0.769072L3.83117 0.0190875C4.18429 -0.0621608 4.54678 0.12221 4.69053 0.453453L6.1905 3.95338C6.32175 4.25962 6.23425 4.61899 5.97488 4.82836L4.08117 6.37833C5.20615 8.77515 7.17173 10.7689 9.61855 11.9157L11.1685 10.022C11.381 9.76263 11.7373 9.67513 12.0435 9.80638L15.5434 11.3063C15.8778 11.4532 16.0622 11.8157 15.9809 12.1688L15.2309 15.4188C15.1528 15.7563 14.8528 16 14.4997 16C6.49674 16 0 9.51576 0 1.50031C0 1.15031 0.240622 0.847195 0.58124 0.769072Z"
                className={`${
                  scrolled ? "fill-gray-900" : "fill-current"
                } hover:text-primary-600  transition-colors duration-300 ease-linear`}
              />
            </svg>
          </a>
        </div>
        <div className="flex flex-auto justify-center lg:justify-start">
          <Link to="/">
            <img
              src={logo}
              alt="Realsynch Logo"
              width={230}
              height={48}
              className="w-[153px] lg:w-[230px]"
            />
          </Link>
        </div>
        <ul
          id="navigation-desktop"
          className="hidden lg:ml-6 lg:flex lg:flex-row lg:items-center lg:justify-center lg:space-x-5 xl:ml-10 xl:space-x-8"
        >
          <li
            className="relative"
            role="presentation"
            onMouseEnter={isHoveringSubMenu1}
            onMouseLeave={notHoveringSubMenu1}
          >
            <div
              className={`relative inline cursor-default pb-8 font-body text-sm font-semibold no-underline ${
                headerStyle === "overlap"
                  ? "text-white hover:text-white"
                  : "!text-gray-900 hover:text-gray-900"
              } ${
                scrolled && "!text-gray-900 hover:text-gray-900"
              } transition-all duration-300 ease-linear `}
            >
              Product <i className="far fa-chevron-down"></i>
            </div>
            {/* <ul
              className={`absolute top-0 z-10 flex min-w-[168px] -translate-x-8  transform flex-col space-y-2.5 rounded-2xl bg-white px-6 py-5 shadow-4xl transition-all duration-300 ease-linear ${
                subMenuHovering1
                  ? " visible translate-y-[52px] opacity-100"
                  : "invisible translate-y-20 opacity-0"
              }`}
            >
              {navigation.product.map((item) => (
                <li key={item.name} className="whitespace-nowrap">
                  <Link
                    to={item.href}
                    target={item.outbound}
                    className="text-sm font-semibold text-typography-body no-underline hover:text-primary-700"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
              <li className="whitespace-nowrap">
                <a
                  href="https://cbx.realsynch.com/cbx-page"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm font-semibold text-typography-body no-underline hover:text-primary-700"
                >
                  CBXxxx
                </a>
              </li>
            </ul> */}
            <ul
              className={`absolute top-0 z-10 grid min-w-[721px] -translate-x-8 transform grid-cols-3 flex-row gap-x-20 rounded-2xl bg-white px-6 py-5 shadow-4xl transition-all duration-300 ease-linear ${
                subMenuHovering1
                  ? " visible translate-y-[52px] opacity-100"
                  : " invisible translate-y-20 opacity-0"
              }`}
            >
              <div className="w-[231px]">
                <div className="text-[14px] font-semibold uppercase text-[#ccc]">
                  Product
                </div>
                <Link
                  to="/product/business-intelligence/"
                  className="mt-6 flex flex-col gap-y-4 text-base font-semibold text-black no-underline hover:text-primary-700"
                >
                  <StaticImage
                    src="../../images/global/navbar/menu-image.png"
                    alt="Menu Image"
                    placeholder="none"
                    width={487}
                    height={358}
                    className="w-[190px] md:w-[230px]"
                  />
                  Business Intelligence Platform
                </Link>
              </div>

              <div className="w-[152px]">
                <div className="text-[14px] font-semibold uppercase text-[#ccc]">
                  Integrations
                </div>
                <div className="mt-6 flex flex-col gap-y-6">
                  <Link
                    to="/how-it-works/"
                    className="text-base font-semibold text-black no-underline hover:text-primary-700"
                  >
                    How It Works
                  </Link>
                  <Link
                    to="/real-estate-software-integrations/"
                    className="text-base font-semibold text-black no-underline hover:text-primary-700"
                  >
                    Supported Systems
                  </Link>
                </div>
              </div>
              <div className="w-[130px]">
                <div className="text-[14px] font-semibold uppercase text-[#ccc]">
                  Success Stories
                </div>
                <div className="mt-6 flex flex-col gap-y-6">
                  <Link
                    to="/product/case-studies/"
                    className="text-base font-semibold text-black no-underline hover:text-primary-700"
                  >
                    Case Studies
                  </Link>
                  <Link
                    to="/reviews/"
                    className="text-base font-semibold text-black no-underline hover:text-primary-700"
                  >
                    Testimonials
                  </Link>
                </div>
              </div>
            </ul>
          </li>

          <li
            className="relative"
            role="presentation"
            onMouseEnter={isHoveringSubMenu2}
            onMouseLeave={notHoveringSubMenu2}
          >
            <Link
              to="/pricing/"
              className={`relative inline pb-8 font-body text-sm font-semibold no-underline ${
                headerStyle === "overlap"
                  ? "text-white hover:text-white"
                  : "!text-gray-900 hover:text-gray-900"
              } ${scrolled && "!text-gray-900 hover:text-gray-900"}`}
            >
              Plans
            </Link>
            {/* <ul
                className={`absolute top-0 z-10 flex min-w-[168px] -translate-x-8  transform flex-col space-y-2.5 rounded-2xl bg-white px-6 py-5 shadow-4xl transition-all duration-300 ease-linear ${subMenuHovering2
                    ? " visible translate-y-[52px] opacity-100"
                    : "invisible translate-y-20 opacity-0"
                  }`}
              >
                {navigation.pricing.map((item) => (
                  <li key={item.name} className="whitespace-nowrap">
                    <Link
                      to={item.href}
                      className="text-sm font-semibold text-typography-body no-underline hover:text-primary-700"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
              </ul> */}
          </li>

          {/* <li>
              <Link
                to="/real-estate-software-integrations/"
                className={`inline font-body text-sm font-semibold no-underline ${
                  headerStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "text-gray-900 hover:text-gray-900"
                } ${scrolled && "!text-gray-900 hover:text-gray-900"}`}
              >
                Integrations
              </Link>
            </li> */}

          <li
            className="relative"
            role="presentation"
            onMouseEnter={isHoveringSubMenu4}
            onMouseLeave={notHoveringSubMenu4}
          >
            <Link
              to="#"
              className={`relative inline pb-8 font-body text-sm font-semibold no-underline ${
                headerStyle === "overlap"
                  ? "text-white hover:text-white"
                  : "!text-gray-900 hover:text-gray-900"
              } ${scrolled && "!text-gray-900 hover:text-gray-900"}`}
            >
              Resources <i className="far fa-chevron-down"></i>
            </Link>
            <ul
              className={`absolute top-0 z-10 flex min-w-[168px] -translate-x-8  transform flex-col space-y-2.5 rounded-2xl bg-white px-6 py-5 shadow-4xl transition-all duration-300 ease-linear ${
                subMenuHovering4
                  ? " visible translate-y-[52px] opacity-100"
                  : "invisible translate-y-20 opacity-0"
              }`}
            >
              {navigation.resources.map((item) => (
                <li key={item.name} className="whitespace-nowrap">
                  <Link
                    to={item.href}
                    className="text-sm font-semibold text-typography-body no-underline hover:text-primary-700"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
              <li className="whitespace-nowrap">
                <a
                  href="https://support.realsynch.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm font-semibold text-typography-body no-underline hover:text-primary-700"
                >
                  Support
                </a>
              </li>
            </ul>
          </li>
          {/* <li
              className="relative"
              role="presentation"
              onMouseEnter={isHoveringSubMenu5}
              onMouseLeave={notHoveringSubMenu5}
            >
              <Link
                to="#"
                className={`relative inline pb-8 font-body text-sm font-semibold no-underline ${
                  headerStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "text-gray-900 hover:text-gray-900"
                } ${scrolled && "!text-gray-900 hover:text-gray-900"}`}
              >
                Testimonials
              </Link>
              <ul
                className={`absolute top-0 z-10 flex min-w-[168px] -translate-x-8  transform flex-col space-y-2.5 rounded-2xl bg-white px-6 py-5 shadow-4xl transition-all duration-300 ease-linear ${
                  subMenuHovering5
                    ? " visible translate-y-[52px] opacity-100"
                    : "invisible translate-y-20 opacity-0"
                }`}
              >
                {navigation.testimonials.map((item) => (
                  <li key={item.name} className="whitespace-nowrap">
                    <Link
                      to={item.href}
                      className="text-sm font-semibold text-typography-body no-underline hover:text-primary-700"
                    >
                      {item.name}
                    </Link>
                  </li>
                ))}
                {/*   <li className="whitespace-nowrap">
                  <a
                    href="/reviews/"
                    target="_self"
                    rel="noreferrer"
                    className="text-sm font-semibold text-typography-body no-underline hover:text-primary-700"
                  >
                    Client Reviews
                  </a>
                </li> */}
          {/* </ul>
            </li> */}
          {/* <li>
              <Link
                to="/reviews/"
                className={`inline font-body text-sm font-semibold no-underline ${
                  headerStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "text-gray-900 hover:text-gray-900"
                } ${scrolled && "!text-gray-900 hover:text-gray-900"}`}
              >
                Reviews
              </Link>
            </li> */}
          {/* <li>
              <button
                data-modal-open="modal-contact"
                className={`inline font-body text-sm font-semibold no-underline ${
                  headerStyle === "overlap"
                    ? "text-white hover:text-white"
                    : "text-gray-900 hover:text-gray-900"
                } ${scrolled && "!text-gray-900 hover:text-gray-900"}`}
              >
                Contact
              </button>
            </li> */}
        </ul>

        <div className="flex flex-auto items-center justify-end">
          <div className="hidden items-center space-x-4 lg:inline-flex">
            <a
              href="https://client.realsynch.com/"
              className={`${
                customTheme === "light-pink" ? "text-[#3232D1]" : "text-white"
              } mr-6 flex gap-x-1 font-heading font-semibold leading-[24px]  no-underline  ${
                scrolled && "!text-gray-900 hover:text-gray-900"
              }`}
            >
              {" "}
              {customTheme === "light-pink" || scrolled ? (
                <StaticImage
                  src="../../images/global/navbar/user-login-icon-dark.svg"
                  alt="Realsynch Logo"
                  placeholder="none"
                  width={24}
                  height={24}
                  className="w-[24px] md:w-[24px]"
                />
              ) : (
                <StaticImage
                  src="../../images/global/navbar/user-login-icon.svg"
                  alt="Realsynch Logo"
                  placeholder="none"
                  width={24}
                  height={24}
                  className="w-[24px] md:w-[24px]"
                />
              )}
              Login
            </a>{" "}
            <a
              href="https://app.realsynch.com/login"
              className={`${
                customTheme === "light-pink" ? "text-[#3232D1]" : "text-white"
              } mr-6 flex gap-x-1 font-heading  font-semibold leading-[24px] no-underline ${
                scrolled && "!text-gray-900 hover:text-gray-900"
              }`}
            >
              {" "}
              {customTheme === "light-pink" || scrolled ? (
                <StaticImage
                  src="../../images/global/navbar/legacy-login-icon-dark.svg"
                  alt="Realsynch Logo"
                  placeholder="none"
                  width={24}
                  height={24}
                  className="w-[24px] md:w-[24px]"
                />
              ) : (
                <StaticImage
                  src="../../images/global/navbar/legacy-login-icon.svg"
                  alt="Realsynch Logo"
                  placeholder="none"
                  width={24}
                  height={24}
                  className="w-[24px] md:w-[24px]"
                />
              )}
              Legacy Login
            </a>
            <ButtonSolid
              // modal="modal-contact"
              altStyle={buttonAltStyle}
              text="Start Free Trial"
              href="/free-trial"
              className="min-w-[126px]"
            />
          </div>

          <div className="lg:hidden" ref={node}>
            {/* Burger */}
            <Burger
              offcanvasOpen={offcanvasOpen}
              setOffcanvasOpen={setOffcanvasOpen}
              headerStyle={headerStyle}
              scrolled={scrolled}
              aria-controls="offcanvas-navigation"
            />

            {/* Mobile Nav */}
            <OffCanvas
              offcanvasOpen={offcanvasOpen}
              offcanvasOffset={offcanvasOffset}
              id="offcanvas-navigation"
            >
              <div>
                <ul id="navigation-mobile" className="mb-16 px-4 text-center">
                  <Accordion
                    allowZeroExpanded={true}
                    className="flex flex-col space-y-6"
                  >
                    <li>
                      <AccordionItem uuid={1}>
                        <AccordionItemButton className="flex items-center justify-center focus:outline-none">
                          <AccordionItemState>
                            {(state) => {
                              return (
                                <>
                                  <div
                                    className={`mb-0 text-3xl font-bold no-underline transition-colors duration-300 ease-linear ${
                                      state.expanded
                                        ? "text-primary-700"
                                        : "text-gray-900 hover:text-primary-700"
                                    }`}
                                  >
                                    Product
                                  </div>
                                </>
                              );
                            }}
                          </AccordionItemState>
                        </AccordionItemButton>

                        <AccordionItemPanel className="pt-4">
                          <ul className="space-y-3.5">
                            {navigation.product.map((item) => (
                              <li key={item.name} className="whitespace-nowrap">
                                <Link
                                  to={item.href}
                                  onClick={clickHandler}
                                  className="block bg-transparent font-normal text-gray-900 no-underline hover:text-primary-700"
                                >
                                  {item.name}
                                </Link>
                              </li>
                            ))}
                            {/* <li className="whitespace-nowrap">
                              <a
                                href="https://cbx.realsynch.com/cbx-page"
                                target="_blank"
                                rel="noreferrer"
                                onClick={clickHandler}
                                className="block bg-transparent font-normal text-gray-900 no-underline hover:text-primary-700"
                              >
                                CBX
                              </a>
                            </li> */}
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </li>

                    <li>
                      <AccordionItem uuid={2}>
                        <AccordionItemButton className="flex items-center justify-center focus:outline-none">
                          <AccordionItemState>
                            {(state) => {
                              return (
                                <>
                                  <div
                                    className={`mb-0 text-3xl font-bold no-underline transition-colors duration-300 ease-linear ${
                                      state.expanded
                                        ? "text-primary-700"
                                        : "text-gray-900 hover:text-primary-700"
                                    }`}
                                  >
                                    Integrations
                                  </div>
                                </>
                              );
                            }}
                          </AccordionItemState>
                        </AccordionItemButton>

                        <AccordionItemPanel className="pt-4">
                          <ul className="space-y-3.5">
                            {navigation.integrations.map((item) => (
                              <li key={item.name} className="whitespace-nowrap">
                                <Link
                                  to={item.href}
                                  onClick={clickHandler}
                                  className="block bg-transparent font-normal text-gray-900 no-underline hover:text-primary-700"
                                >
                                  {item.name}
                                </Link>
                              </li>
                            ))}
                            {/* <li className="whitespace-nowrap">
                              <a
                                href="https://cbx.realsynch.com/cbx-page"
                                target="_blank"
                                rel="noreferrer"
                                onClick={clickHandler}
                                className="block bg-transparent font-normal text-gray-900 no-underline hover:text-primary-700"
                              >
                                CBX
                              </a>
                            </li> */}
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </li>
                    <li>
                      <AccordionItem uuid={3}>
                        <AccordionItemButton className="flex items-center justify-center focus:outline-none">
                          <AccordionItemState>
                            {(state) => {
                              return (
                                <>
                                  <div
                                    className={`mb-0 text-3xl font-bold no-underline transition-colors duration-300 ease-linear ${
                                      state.expanded
                                        ? "text-primary-700"
                                        : "text-gray-900 hover:text-primary-700"
                                    }`}
                                  >
                                    Success Stories
                                  </div>
                                </>
                              );
                            }}
                          </AccordionItemState>
                        </AccordionItemButton>

                        <AccordionItemPanel className="pt-4">
                          <ul className="space-y-3.5">
                            {navigation.successStories.map((item) => (
                              <li key={item.name} className="whitespace-nowrap">
                                <Link
                                  to={item.href}
                                  onClick={clickHandler}
                                  className="block bg-transparent font-normal text-gray-900 no-underline hover:text-primary-700"
                                >
                                  {item.name}
                                </Link>
                              </li>
                            ))}
                            {/* <li className="whitespace-nowrap">
                              <a
                                href="https://cbx.realsynch.com/cbx-page"
                                target="_blank"
                                rel="noreferrer"
                                onClick={clickHandler}
                                className="block bg-transparent font-normal text-gray-900 no-underline hover:text-primary-700"
                              >
                                CBX
                              </a>
                            </li> */}
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </li>
                    {/* <li>
                      <AccordionItem uuid={2}>
                        <AccordionItemButton className="flex items-center justify-center focus:outline-none">
                          <AccordionItemState>
                            {(state) => {
                              return (
                                <>
                                  <div
                                    className={`mb-0 text-3xl font-bold no-underline transition-colors duration-300 ease-linear ${
                                      state.expanded
                                        ? "text-primary-700"
                                        : "text-gray-900 hover:text-primary-700"
                                    }`}
                                  >
                                    Pricing
                                  </div>
                                </>
                              );
                            }}
                          </AccordionItemState>
                        </AccordionItemButton>

                        <AccordionItemPanel className="pt-4">
                          <ul className="space-y-3.5">
                            {navigation.pricing.map((item) => (
                              <li key={item.name} className="whitespace-nowrap">
                                <Link
                                  to={item.href}
                                  onClick={clickHandler}
                                  className="block bg-transparent font-normal text-gray-900 no-underline hover:text-primary-700"
                                >
                                  {item.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </li> */}

                    <li>
                      <Link
                        to="/pricing/"
                        onClick={clickHandler}
                        className="text-3xl font-bold text-gray-900 no-underline transition-colors duration-300 ease-linear hover:text-primary-700"
                      >
                        Plans
                      </Link>
                    </li>

                    {/* <li>
                      <Link
                        to="/real-estate-software-integrations/"
                        onClick={clickHandler}
                        className="text-3xl font-bold text-gray-900 no-underline transition-colors duration-300 ease-linear hover:text-primary-700"
                      >
                        Integrations
                      </Link>
                    </li> */}

                    <li>
                      <AccordionItem uuid={4}>
                        <AccordionItemButton className="flex items-center justify-center focus:outline-none">
                          <AccordionItemState>
                            {(state) => {
                              return (
                                <>
                                  <div
                                    className={`mb-0 text-3xl font-bold no-underline transition-colors duration-300 ease-linear ${
                                      state.expanded
                                        ? "text-primary-700"
                                        : "text-gray-900 hover:text-primary-700"
                                    }`}
                                  >
                                    Resources
                                  </div>
                                </>
                              );
                            }}
                          </AccordionItemState>
                        </AccordionItemButton>

                        <AccordionItemPanel className="pt-4">
                          <ul className="space-y-3.5">
                            {navigation.resources.map((item) => (
                              <li key={item.name} className="whitespace-nowrap">
                                <Link
                                  to={item.href}
                                  onClick={clickHandler}
                                  className="block bg-transparent font-normal text-primary-900 no-underline hover:text-primary-700"
                                >
                                  {item.name}
                                </Link>
                              </li>
                            ))}
                            <li className="whitespace-nowrap">
                              <a
                                href="https://support.realsynch.com/"
                                target="_blank"
                                rel="noreferrer"
                                onClick={clickHandler}
                                className="block bg-transparent font-normal text-primary-900 no-underline hover:text-primary-700"
                              >
                                Support
                              </a>
                            </li>
                          </ul>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </li>
                    <li>
                      <AccordionItem uuid={5}>
                        <AccordionItemButton className="flex items-center justify-center focus:outline-none">
                          <AccordionItemState>
                            {(state) => {
                              return (
                                <>
                                  <div
                                    className={`mb-0 text-3xl font-bold no-underline transition-colors duration-300 ease-linear ${
                                      state.expanded
                                        ? "text-primary-700"
                                        : "text-gray-900 hover:text-primary-700"
                                    }`}
                                  >
                                    {/* <li>
                                      <AccordionItem uuid={5}>
                                        <AccordionItemButton className="flex items-center justify-center focus:outline-none">
                                          <AccordionItemState>
                                            {(state) => {
                                              return (
                                                <>
                                                  <div
                                                    className={`mb-0 text-3xl font-bold no-underline transition-colors duration-300 ease-linear ${
                                                      state.expanded
                                                        ? "text-primary-700"
                                                        : "text-gray-900 hover:text-primary-700"
                                                    }`}
                                                  >
                                                    Testimonials
                                                  </div>
                                                </>
                                              );
                                            }}
                                          </AccordionItemState>
                                        </AccordionItemButton>

                                        <AccordionItemPanel className="pt-4">
                                          <ul className="space-y-3.5">
                                            {navigation.testimonials.map(
                                              (item) => (
                                                <li
                                                  key={item.name}
                                                  className="whitespace-nowrap"
                                                >
                                                  <Link
                                                    to={item.href}
                                                    onClick={clickHandler}
                                                    className="block bg-transparent font-normal text-primary-900 no-underline hover:text-primary-700"
                                                  >
                                                    {item.name}
                                                  </Link>
                                                </li>
                                              )
                                            )}
                                            <li className="whitespace-nowrap">
                                              <a
                                                href="/case/"
                                                target="_self"
                                                rel="noreferrer"
                                                onClick={clickHandler}
                                                className="block bg-transparent font-normal text-primary-900 no-underline hover:text-primary-700"
                                              >
                                                Case Studies
                                              </a>
                                            </li>
                                          </ul>
                                        </AccordionItemPanel>
                                      </AccordionItem>
                                    </li> */}
                                  </div>
                                </>
                              );
                            }}
                          </AccordionItemState>
                        </AccordionItemButton>

                        {/* <AccordionItemPanel className="pt-4">
                          <ul className="space-y-3.5">
                            {navigation.testimonials.map((item) => (
                              <li key={item.name} className="whitespace-nowrap">
                                <Link
                                  to={item.href}
                                  onClick={clickHandler}
                                  className="block bg-transparent font-normal text-primary-900 no-underline hover:text-primary-700"
                                >
                                  {item.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </AccordionItemPanel> */}
                      </AccordionItem>
                    </li>

                    {/* <li>
                      <button
                        data-modal-open="modal-contact"
                        className="text-3xl font-bold text-gray-900 no-underline transition-colors duration-300 ease-linear hover:text-primary-700"
                      >
                        Contact
                      </button>
                    </li> */}
                  </Accordion>
                </ul>

                <div className="flex flex-wrap items-center justify-center space-y-4 md:space-y-0 md:space-x-4">
                  <ButtonGhost
                    href="https://client.realsynch.com"
                    outboundLink={true}
                    text="Log In"
                    className="w-full md:w-auto"
                  />{" "}
                  <ButtonGhost
                    href="https://app.realsynch.com/login"
                    outboundLink={true}
                    text="Legacy Log In"
                    className="w-full md:w-auto"
                  />
                  <ButtonSolid
                    // modal="modal-contact"
                    altStyle={2}
                    text="Start Free Trial"
                    href="/free-trial"
                    className="w-full md:w-auto"
                  />
                </div>
              </div>
            </OffCanvas>
          </div>
        </div>
      </div>
    </nav>
  );
};
export default MainNav;
